const parseEntityDescription = (description: string | null | undefined) => {
  const text = description ?? "";

  // First replace newlines with <br>
  const withLineBreaks = text.replace(/(?:\r\n|\r|\n)/g, "<br>");

  // Then convert URLs to anchor tags
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return withLineBreaks.replace(
    urlRegex,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  );
};

export { parseEntityDescription };
